import { PermissionsPage, ToolsPage_, AuditLogsPage, PaymentProvidersPage, PaymentPackagesPage, PaymentMethodRequestsPage } from '../pages/settingsPage/pages';
import { AccountingUsersPage, OverviewPage, TransactionsPage } from '../pages/accountingPage/pages';
import PrivateRoute from '@/components/custom/PrivateRoute.tsx';
import { AdminUserPermissionsEnum } from '@/lib/enum.ts';
import { SecuredComponent } from '../components/hoc';
import { NoPermission } from '../components/custom';
import { Route, Routes } from 'react-router-dom';
import LoginPage from '@/pages/LoginPage.tsx';
import routes from '@/lib/routes';
import { PromoCodesPage, PromotionsPage } from '../pages/marketingPage/pages';
import { BulkNotificationPage } from '../pages/bulkNotificationPage';
import { EventsPage } from '../pages/eventsPage';
import { EventPage as EventsEventPage, CreateEventPage } from '../pages/eventsPage/pages';
import CreatePromotionPage from '../pages/marketingPage/pages/PromotionsPage/pages/CreatePromotionPage';
import {
	ReportConversationPage,
	VerificationsHistoryPage,
	UserSubAccountsPage,
	CertificationsPage,
	VerificationsPage,
	AccountingPage,
	BioReviewPage,
	ReferralPage,
	SettingsPage,
	NotFoundPage,
	ReportsPage,
	UsersPage,
	AdminMessagesPage,
	MarketingPage,
	HomePage,
	UserPage
} from '../pages';

const AppRoutes = () => (
	<Routes>
		{/* Private routes */}
		<Route path={routes.nav.home} element={<PrivateRoute page={<HomePage />} />} />
		<Route
			path={routes.nav.certifications}
			element={
				<SecuredComponent
					permissionsRequired={[AdminUserPermissionsEnum.CERTIFICATION]}
					accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.CERTIFICATION]} />}
				>
					<PrivateRoute page={<CertificationsPage />} />
				</SecuredComponent>
			}
		/>
		<Route
			path={routes.nav.verifications}
			element={
				<SecuredComponent
					permissionsRequired={[AdminUserPermissionsEnum.PHOTO_VERIF]}
					accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.PHOTO_VERIF]} />}
				>
					<PrivateRoute page={<VerificationsPage />} />
				</SecuredComponent>
			}
		/>
		<Route
			path={routes.nav.referral}
			element={
				<SecuredComponent
					permissionsRequired={[AdminUserPermissionsEnum.REFERRAL]}
					accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.REFERRAL]} />}
				>
					<PrivateRoute page={<ReferralPage />} />
				</SecuredComponent>
			}
		/>
		<Route
			path={routes.nav.bioReview}
			element={
				<SecuredComponent
					permissionsRequired={[AdminUserPermissionsEnum.BIO_VERIF]}
					accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.BIO_VERIF]} />}
				>
					<PrivateRoute page={<BioReviewPage />} />
				</SecuredComponent>
			}
		/>
		<Route
			path={routes.nav.reports.base}
			element={
				<SecuredComponent
					permissionsRequired={[AdminUserPermissionsEnum.REPORT]}
					accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.REPORT]} />}
				>
					<PrivateRoute page={<ReportsPage />} />
				</SecuredComponent>
			}
		/>
		<Route
			path={routes.nav.users.path}
			element={
				<SecuredComponent
					permissionsRequired={[AdminUserPermissionsEnum.USERS]}
					accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.USERS]} />}
				>
					<PrivateRoute page={<UsersPage />} />
				</SecuredComponent>
			}
		/>
		{/* #region Marketing */}
		<Route
			path={routes.nav.marketing.path}
			element={
				<SecuredComponent
					permissionsRequired={[AdminUserPermissionsEnum.MARKETING, AdminUserPermissionsEnum.PROMOTION, AdminUserPermissionsEnum.BULK_NOTIFICATIONS]}
					accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.MARKETING, AdminUserPermissionsEnum.PROMOTION, AdminUserPermissionsEnum.BULK_NOTIFICATIONS]} />}
				>
					<PrivateRoute page={<MarketingPage />} />
				</SecuredComponent>
			}
		>
			<Route path={routes.nav.marketing.messages.path} element={<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.MARKETING]}><AdminMessagesPage useLayout={false} /></SecuredComponent>} />
			<Route path={routes.nav.marketing.promotions.path} element={<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.PROMOTION]}><PromotionsPage /></SecuredComponent>} />
			<Route path={routes.nav.marketing.promoCodes.path} element={<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.PROMOTION]}><PromoCodesPage /></SecuredComponent>} />
			<Route path={routes.nav.marketing.bulkNotifications.path} element={<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.BULK_NOTIFICATIONS]}><BulkNotificationPage /></SecuredComponent>} />
		</Route>
		{/* #endregion */}
		{/* #region Events */}
		<Route
			path={routes.nav.events.path}
			element={
				<SecuredComponent
					permissionsRequired={[AdminUserPermissionsEnum.EVENT]}
					accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.EVENT]} />}
				>
					<PrivateRoute page={<EventsPage />} />
				</SecuredComponent>
			}
		>
			<Route index element={<EventsEventPage />} />
		</Route>
		{/* #endregion */}
		<Route
			path={routes.nav.verificationsHistory.path}
			element={
				<SecuredComponent
					permissionsRequired={[AdminUserPermissionsEnum.HISTORY]}
					accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.HISTORY]} />}
				>
					<PrivateRoute page={<VerificationsHistoryPage />} />
				</SecuredComponent>
			}
		/>
		{/* #region Accounting */}
		<Route
			path={routes.nav.accounting.path}
			element={
				<SecuredComponent
					permissionsRequired={[
						AdminUserPermissionsEnum.ACCOUNTING_OVERVIEW,
						AdminUserPermissionsEnum.ACCOUNTING_MANAGER,
					]}
					accessDeniedComponent={
						<NoPermission permissionsExpected={[
							AdminUserPermissionsEnum.ACCOUNTING_OVERVIEW,
							AdminUserPermissionsEnum.ACCOUNTING_MANAGER,
						]} />
					}
				>
					<PrivateRoute page={<AccountingPage />} />
				</SecuredComponent>
			}
		>
			<Route
				path={routes.nav.accounting.overview.path}
				element={
					<SecuredComponent
						permissionsRequired={[AdminUserPermissionsEnum.ACCOUNTING_OVERVIEW]}
						accessDeniedComponent={
							<NoPermission permissionsExpected={[AdminUserPermissionsEnum.ACCOUNTING_OVERVIEW]} />
						}
					>
						<OverviewPage />
					</SecuredComponent>
				}
			/>
			<Route
				path={routes.nav.accounting.transactions.path}
				element={
					<SecuredComponent
						permissionsRequired={[AdminUserPermissionsEnum.ACCOUNTING_MANAGER]}
						accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.ACCOUNTING_MANAGER]} />}
					>
						<TransactionsPage />
					</SecuredComponent>
				}
			/>
			<Route
				path={routes.nav.accounting.users.path}
				element={
					<SecuredComponent
						permissionsRequired={[AdminUserPermissionsEnum.ACCOUNTING_MANAGER]}
						accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.ACCOUNTING_MANAGER]} />}
					>
						<AccountingUsersPage />
					</SecuredComponent>
				}
			/>
		</Route>
		{/* #endregion */}
		{/* #region Settings */}
		<Route
			path={routes.nav.settings.path}
			element={
				<SecuredComponent
					permissionsRequired={[AdminUserPermissionsEnum.SETTINGS]}
					accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.SETTINGS]} />}
				>
					<PrivateRoute page={<SettingsPage />} />
				</SecuredComponent>
			}
		>
			<Route path={routes.nav.settings.permissions.path} element={<PermissionsPage />} />
			<Route path={routes.nav.settings.tools.path} element={<ToolsPage_ />} />
			<Route
					path={routes.nav.settings.paymentProviders.path}
					element={
						<SecuredComponent
							permissionsRequired={[AdminUserPermissionsEnum.PAYMENT_PROVIDERS]}
							accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.PAYMENT_PROVIDERS]} />}
						>
							<PaymentProvidersPage />
						</SecuredComponent>
					}
				/>
			<Route
				path={routes.nav.settings.paymentPackages.path}
				element={
					<SecuredComponent
						permissionsRequired={[AdminUserPermissionsEnum.PAYMENT_PACKAGES]}
						accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.PAYMENT_PACKAGES]} />}
					>
						<PaymentPackagesPage />
					</SecuredComponent>
				}
			/>
			<Route
				path={routes.nav.settings.paymentMethodRequests.path}
				element={
					<SecuredComponent
						permissionsRequired={[AdminUserPermissionsEnum.PAYMENT_METHOD_REQUESTS]}
						accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.PAYMENT_METHOD_REQUESTS]} />}
					>
						<PaymentMethodRequestsPage />
					</SecuredComponent>
				}
			/>
			<Route
				path={routes.nav.settings.auditLogs.path}
				element={
					<SecuredComponent
						permissionsRequired={() => false}
						accessDeniedComponent={<NoPermission />}
					>
						<AuditLogsPage />
					</SecuredComponent>
				}
			/>
		</Route>
		{/* #endregion */}
			<Route
			path={routes.nav.marketing.promotions.create.path}
			element={
				<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.PROMOTION]}>
					<PrivateRoute page={<CreatePromotionPage />} />
				</SecuredComponent>
			}
		/>
		<Route
			path={routes.nav.events.create.path}
			element={
				<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.EVENT]}>
					<PrivateRoute page={<CreateEventPage />} />
				</SecuredComponent>
			}
		/>
		<Route
			path={routes.nav.reportConversation.path}
			element={
				<SecuredComponent
					permissionsRequired={[AdminUserPermissionsEnum.REPORT]}
					accessDeniedComponent={<NoPermission permissionsExpected={[AdminUserPermissionsEnum.REPORT]} />}
				>
					<PrivateRoute page={<ReportConversationPage />} />
				</SecuredComponent>
			}
		/>
		{/* Not permission related routes */}
		<Route path={routes.nav.users.single.path} element={<PrivateRoute page={<UserPage />} />} />
		<Route path={routes.nav.users.single.subAccounts.path} element={<PrivateRoute page={<UserSubAccountsPage />} />} />
		{/* Public routes */}
		<Route path={routes.nav.login} element={<LoginPage />} />
		<Route path="*" element={<NotFoundPage />} />
	</Routes>
);

export default AppRoutes;
